module.exports = __webpack_public_path__ + "img/expansion.e4b19f9e.png";